import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { MaeDocumentoM } from '../../model/mae-documento-bean';
import { ReporteConstanciasM } from 'src/app/model/reporte-bean';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() { }

  exportExcelReporteEmitidosCurso(reporteConstanciasM:ReporteConstanciasM[]) {

    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Constancias');
    let fila:number = 0;

    worksheet.columns = [
      { header: 'NRO', key: 'nro', width: 6 },
      { header: 'FECHA', key: 'f_constancia', width: 12 },
      { header: 'CURSO', key: 'x_curso', width: 60 },
      { header: 'TIPO', key: 'x_tipo', width: 12 },
      { header: 'FORMATO', key: 'x_titulo', width: 14 },
      { header: 'NRO. CONSTANCIA', key: 'x_nro_constancia', width: 20 },
      { header: 'NOMBRES', key: 'x_nombres', width: 40},
      { header: 'CORREO', key: 'x_correo', width: 40},
      { header: 'NOTA', key: 'x_nota', width: 6 },
      { header: 'ENVIO CORREO', key: 'x_envio_correo', width: 10 },
    ];

    reporteConstanciasM.forEach(data => {
      fila = fila + 1;
      let row = worksheet.addRow({nro:fila,f_constancia: data.f_constancia, x_curso:data.x_curso,
        x_tipo: data.x_tipo, x_titulo: data.x_titulo, x_nro_constancia:data.x_nro_constancia, x_nombres:data.x_nombres,
        x_correo:data.x_correo, x_nota:data.x_nota, x_envio_correo:data.x_envio_correo
      },"n");

      row.eachCell((cell, number) => {
        cell.border = {
          top: {style:'thin'},
          left: {style:'thin'},
          bottom: {style:'thin'},
          right: {style:'thin'}
        }
      })

    });

    worksheet.getRow(1).eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '4167B8' },
        bgColor: { argb: '' }
      }
      cell.font = {
        color: { argb: 'FFFFFF' },
        size: 11,
      }
    })

    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'ConstanciasCurso.xlsx');
    })

  }

  exportExcelReporteTotalAlumnos(reporteConstanciasM:ReporteConstanciasM[]) {

    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Total');
    let fila:number = 0;

    worksheet.columns = [
      { header: 'NRO', key: 'nro', width: 6 },
      { header: 'FECHA', key: 'f_constancia', width: 12 },
      { header: 'CURSO', key: 'x_curso', width: 60 },
      { header: 'FORMATO', key: 'x_titulo', width: 14 },
      { header: 'TOTA ALUMNOS', key: 'x_nro_participantes', width: 10 },
    ];

    reporteConstanciasM.forEach(data => {
      fila = fila + 1;
      let row = worksheet.addRow({nro:fila,f_constancia: data.f_constancia, x_curso:data.x_curso,
        x_titulo: data.x_titulo, x_nro_participantes:data.x_nro_participantes
      },"n");
      row.eachCell((cell, number) => {
        cell.border = {
          top: {style:'thin'},
          left: {style:'thin'},
          bottom: {style:'thin'},
          right: {style:'thin'}
        }
      })

    });

    worksheet.getRow(1).eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '4167B8' },
        bgColor: { argb: '' }
      }
      cell.font = {
        color: { argb: 'FFFFFF' },
        size: 11,
      }
    })

    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'TotalAlumnos.xlsx');
    })

  }

}
